import styles from "./banner.module.css";
import LazyLoad from "react-lazyload";

const Banner = () => {
  return (
    <section className={styles.ctn}>
      <LazyLoad>
        <img
          className={styles.logo}
          src="https://bucket.zhiyun-tech.com/detail/m3challenge-logo.png"
          alt=""
        />
      </LazyLoad>
      <div className={`${styles.h0} h0`}>Short B-Roll Challenge</div>
      <div className={styles.dateBox}>
        <h2>Nov.15 - Dec.08</h2>
        <div className={styles.dateYearBox}>
          <h5>2</h5>
          <h5>0</h5>
          <h5>2</h5>
          <h5>1</h5>
        </div>
      </div>

      {/* <iframe
      className={styles.youtubeEmbed}
        width="560"
        height="315"
        src="https://www.youtube-nocookie.com/embed/prL8-gJ33nI"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe> */}
      <a href="https://www.youtube.com/channel/UCRte954rw0oeMWFroy_ClAw" target="_blank" className={styles.youtubeEmbed}>
          <svg className={styles.youtubePlayButton} height="100%" version="1.1" viewBox="0 0 68 48" width="100%">
            <path
              class="ytp-large-play-button-bg"
              d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z"
              fill="#f00"
            ></path>
            <path d="M 45,24 27,14 27,34" fill="#fff"></path>
          </svg>
        {/* <img
          className={styles.youtubeImg}
          src="https://bucket.zhiyun-tech.com/detail/m3challenge-youtubeImg.png"
          alt=""
        /> */}

        <img className={styles.youtubeImg} src="https://bucket.zhiyun-tech.com/detail/m3challenge-youtube-poster.png" alt="" />
      </a>

      <div className={styles.mask}></div>
    </section>
  );
};

export default Banner;
